/**
 * Module dependencies.
 */

import { Button } from 'app/components/atoms/button/button';
import { resolveAppPath } from 'app/core/utils/url-resolver';
import { appRoutes } from 'app/routes';
import { AlignJustify } from 'lucide-react';
import React from 'react';
import { createSearchParams, useNavigate } from 'react-router-dom';

/**
 * `Props` type.
 */

type Props = {
  item: any;
};

/**
 * Export `MovementsButton` component.
 */

export function MovementsButton({ item }: Props): JSX.Element {
  const navigate = useNavigate();

  return (
    <Button
      icon={<AlignJustify className={'h-4 w-4'} />}
      onClick={event => {
        event?.stopPropagation();

        const budgetId = item.id;

        if (!budgetId) {
          return;
        }

        const query = {
          filter: JSON.stringify({ budgetId })
        };

        const path = resolveAppPath(appRoutes.dashboard.projects.project.movements, {
          projectId: item.projectId
        });

        navigate({
          pathname: path,
          search: `?${createSearchParams(query as any)}`
        });
      }}
      size={'small'}
    />
  );
}
